import { EmojiServiceResponse } from '@atlaskit/emoji/types';
import emojis from '../../../assets/atlassian-emoji.json';

export const getAtlassianEmojiData = (): EmojiServiceResponse =>
  emojis as EmojiServiceResponse;
